@use "./DashboardLayout.horizontal.scss" as horizontal;
@use "./DashboardLayout.vertical.scss" as vertical;

$breakpoint: 800px;

.dashboard-layout {
  display: flex;
  height: 100%;
  &.desktop-variant\: {
    &horizontal {
      @include horizontal.layout($breakpoint);
    }
    &vertical {
      @include vertical.layout($breakpoint);
    }
  }
}

// Desktop
@media screen and (min-width: $breakpoint) {
  .mobile {
    display: none;
  }
}

// Mobile
@media screen and (max-width: ($breakpoint - 1px)) {
  .desktop {
    display: none;
  }
  .dashboard-layout {
    flex-direction: column-reverse;

    .logo {
      display: none;
    }

    > main {
      flex: 1;
      overflow-y: auto;
    }
    > nav {
      box-sizing: border-box;
      box-shadow: inset 0 1px 0 0 var(--outline);
      .tabs {
        display: flex;
        max-width: 600px;
        height: 80px;
        align-items: center;
        justify-content: space-around;
        margin: 0 auto;
        gap: 4px;
      }
    }
  }

  .tab {
    width: 80px;
    height: 60px;
    border-radius: 16px;
    transition: var(--normal-s);

    &:not(.active) {
      color: var(--moderate-weak);
    }
    .mobile {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
